
import { useMutation } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { ChecklistInput } from 'types'

export const useAddChecklistTask = () => {
  return useMutation({
    mutationFn: async (newTasks: ChecklistInput[]) => {
      return axios.post(`${baseUrl}/aws/checklists/add_task`, { tasks: newTasks })
    },
    onSuccess: () => {
      console.log('✅ New task added successfully.')
      // queryClient.invalidateQueries({ queryKey: ['checklists'] }) // Refresh checklist
    },
    onError: error => {
      console.error('❌ Error adding new task:', error)
    },
  })
}
